// extracted by mini-css-extract-plugin
module.exports = {"options":"style__options__56iVy","pills":"style__pills__uC7iT","historyLegend":"style__historyLegend__0PU92","historySummary":"style__historySummary__Ttdn8"};